/**
 * Created by Pali on 03/03/25.
 */

angular.module("screensApp")

  .controller("DocumentController", function ($scope, $rootScope, AutoCaptureService, BiometryService, OnboardingService, CameraHealthCheckService) {
    // Declare variables in the controller's scope
    var instructionChangeEvent = "document-auto-capture:instruction-changed";

    // Definovanie handleInstructionChange raz, aby referencia bola stabilna
    $scope.handleInstructionChange = function (event) {
      $scope.lastInstructionCode = event.detail.instructionCode;
      $scope.$apply();
    }

    // Hide Document
    $rootScope.hideDocument = function (destroy) {
      // Nastavenie animacie progressbaru a skrytie hlasky "Dokument sa odosiela..."
      $scope.setDocumentCaptured(false);
      OnboardingService.clearDocumentTimeout();
      OnboardingService.setDocumentPause(true);
      $rootScope.settings.document.show = false;
      $scope.visualState = "";
      $rootScope.$$phase || $rootScope.$apply();
      if (destroy) {
        // zastavujem Camera Health Check servis aby nekontroloval neexistujúci element a nevyhodnotil to ako chybu kamery
        CameraHealthCheckService.stop();
        $('#DocumentInCircleHints').empty();
        // Zrusenie listenera na zmenu instrukcie z api pre preklady a zobrazenie
        document.removeEventListener(instructionChangeEvent, $scope.handleInstructionChange);
      }
    }

    // Funkcia sluzi na nastavenie pociatocneho configu kamery sluziacej na overenie pomocou biometrie
    $scope.onboardingLoadDocumentProps = function () {
      try {
        // Nastavenie animacie progressbaru a skrytie hlasky "Dokument sa odosiela..."
        $scope.setDocumentCaptured(false);
        $('x-dot-document-auto-capture').prop('cameraOptions', {
          onPhotoTaken: documentPhotoTaken,
          onError: function (error) {
            // Spustenie Camera Health Check servisu - kniznica zaznamenala chybu pri spracovani obrazu z kamery
            CameraHealthCheckService.start(document.querySelector('x-dot-document-auto-capture video'));
            // Log exception to console && kibana
            $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: x-dot-document-auto-capture onError: ' + error);
            $rootScope.createLog(2, 'x-dot-document-auto-capture onError()', '# ERROR: ' + error.toString());
          },
          candidateSelectionDurationMillis: $rootScope.config.BiometryOnboardingDocumentCandidateSelectionDuration,
          cameraFacing: $rootScope.config.BiometryFrontCamera,
          thresholds: {
            sharpnessThreshold: $rootScope.config.BiometryOnboardingDocumentSharpnessThreshold
          }
        });
      } catch (err) {
        console.log(err);
      }
    }

    $scope.onboardingLoadDocumentUIProps = function () {
      $('x-dot-document-auto-capture-ui').prop('props', {
        showCameraButtons: true,
      });
      // Pridavanie listenera na zmenu instrukcie z api a pridanie do $scope pre class root elementu na stylovanie zobrazenia a pre preklady
      document.addEventListener(instructionChangeEvent, $scope.handleInstructionChange);
    }

    // Show Document
    $rootScope.showDocument = function (startCamera) {
      $rootScope.settings.document.show = true;
      $rootScope.$$phase || $rootScope.$apply();
      if (startCamera) {
        OnboardingService.setDocumentPause(false);
        if (!$('#documentContainer x-dot-document-auto-capture')?.length) {
          $rootScope.autocaptureDocumentFirstTime();
        }
        // Spustenie Camera Health Check servisu - za kazdych okolnosti lebo moze ostat zamrznuty obraz s dokumentom a potom hrac naskenuje iny dokument ako ma
        CameraHealthCheckService.start(document.querySelector('x-dot-document-auto-capture video'));
      }

    };

    $rootScope.autocaptureDocumentFirstTime = function () {
        $rootScope.settings.document.show = true;
        $rootScope.$$phase || $rootScope.$apply();
        var cam = document.createElement('x-dot-document-auto-capture');
        var ui = document.createElement('x-dot-document-auto-capture-ui');
        cam.setAttribute('id', 'x-dot-document-auto-capture');
        ui.setAttribute('id', 'x-dot-document-auto-capture-ui');
        $('#DocumentInCircleHints').empty().show().append(cam).append(ui);
        $scope.onboardingLoadDocumentProps();
        $scope.onboardingLoadDocumentUIProps();
    }

    // Biometry on top functions
    $rootScope.autoCaptureOnboarding = function (data, destroy) {
      // Priradenie/Zobrazenie chybovej hlasky z nativky
      $scope.errorStateDocument = data?.errorKey || "";
      if ([AutoCaptureService.captureStatesFromNative.idFrontSuccess,
        AutoCaptureService.captureStatesFromNative.idFrontFailed,
        AutoCaptureService.captureStatesFromNative.idBackSuccess,
        AutoCaptureService.captureStatesFromNative.idBackFailed,
        AutoCaptureService.captureStatesFromNative.canceled].includes(data.state)) {
        // Nastavenie animacie progressbaru a skrytie hlasky "Dokument sa odosiela..."
        $scope.setDocumentCaptured(false);
      }
      // Zastavenie vsetkych timeoutov
      BiometryService.clearBiometryTimeout();
      OnboardingService.clearDocumentTimeout();
      switch (data.state) {

        // Stavy k idFront
        case AutoCaptureService.documentCaptureStates.idFront:
          // Odstrani dot web auto capture componentu koli nepredvidatelnemu spravaniu SBSC-63
          $rootScope.stopBiometry(true);
          // Zapnutie skenovania OP prednej strany
          $scope.visualStateDocument = AutoCaptureService.documentCaptureStates.idFront;
          AutoCaptureService.setAutoCaptureState(AutoCaptureService.documentCaptureStates.idFront);
          $rootScope.showDocument(true);

          OnboardingService.setDocumentTimeout(function () {
            // Zrusi skenovanie dokumentov, Odosle info o timeoute na nativeApp
            onboardingIDFrontFailed();
          }, $rootScope.settings.document.hideTimeoutLong, true);
          break;

        case AutoCaptureService.captureStatesFromNative.idFrontSuccess:
          // DIS Digital Identity service - odpoved ~Success pre prednu stranu OP
          if (data.info === "registeredPlayer") {
            // Skenovanie prednej strany OP sa podarilo, hrac existuje v db
            // Na spodnej obrazovke je zobrazene okno pre prihlasenie uz registrovaneho hraca
            // Preto zobrazujeme stav 'idBackSuccess' na vrchnej obrazovke - aby sa hrac riadil pokynmi na dolnej obrazovke SBSC-61
            $scope.visualStateDocument = AutoCaptureService.captureStatesFromNative.idBackSuccess;
            $rootScope.showDocument();
          } else if (data.nextStep === AutoCaptureService.documentCaptureStates.idBack) {
            // Zobrazi info o uspechu 5s
            $scope.visualStateDocument = AutoCaptureService.captureStatesFromNative.idFrontSuccess;
            $rootScope.showDocument();
            // Po 5s so zobrazenim idFrontSuccess ma prejst na skenovanie zadnej strany OP
            OnboardingService.setDocumentTimeout(function () {
              $rootScope.autoCaptureOnboarding({ "state": AutoCaptureService.documentCaptureStates.idBack });
            }, $rootScope.settings.document.hideTimeout, true);
          } else {
            throw Error('data.nextStep !== AutoCaptureService.documentCaptureStates.idBack');
          }
          break;

        case AutoCaptureService.captureStatesFromNative.idFrontFailed:
          // DIS Digital Identity service - odpoved ~Failed pre prednu stranu OP
          // Zobrazi info o neuspechu 5s
          $scope.visualStateDocument = AutoCaptureService.captureStatesFromNative.idFrontFailed;
          $rootScope.showDocument();
          break;

        // Stavy k idBack
        case AutoCaptureService.documentCaptureStates.idBack:
          // Zapnutie skenovania OP zadnej strany
          $scope.visualStateDocument = AutoCaptureService.documentCaptureStates.idBack;
          AutoCaptureService.setAutoCaptureState(AutoCaptureService.documentCaptureStates.idBack);
          $rootScope.showDocument(true);

          OnboardingService.setDocumentTimeout(function () {
            // Timeout pre nacitanie zadnej strany OP
            // Zrusi skenovanie dokumentov, Odosle info o timeoute na nativeApp
            onboardingIDBackFailed();
          }, $rootScope.settings.document.hideTimeoutLong, true);
          break;

        case AutoCaptureService.captureStatesFromNative.idBackSuccess:
          // DIS Digital Identity service - odpoved ~Success pre zadnu stranu OP
          // Zobrazi info o uspechu 5s
          $scope.visualStateDocument = AutoCaptureService.captureStatesFromNative.idBackSuccess;
          $rootScope.showDocument();
          break;

        case AutoCaptureService.captureStatesFromNative.idBackFailed:
          // DIS Digital Identity service - odpoved ~Failed pre zadnu stranu OP
          // Zobrazi info o neuspechu 5s
          $scope.visualStateDocument = AutoCaptureService.captureStatesFromNative.idBackFailed;
          $rootScope.showDocument();
          break;

        case AutoCaptureService.faceCaptureStates.selfie:
          // Zapnutie snimania tvare v procese registracie
          AutoCaptureService.setAutoCaptureState(AutoCaptureService.faceCaptureStates.selfie);
          $rootScope.hideDocument(destroy);
          $rootScope.onboardingSelfie();

          OnboardingService.setDocumentTimeout(function () {
            // Timeout pre nasnimanie selfie
            // Zrusi selfie, Odosle info o timeoute na nativeApp
            onboardingSelfieFailed();
          }, $rootScope.settings.document.hideTimeoutLong, true);
          break;

        case AutoCaptureService.captureStatesFromNative.selfieSuccess:
          // $rootScope.faceCapturing = AutoCaptureService.faceCaptureStates.biometry - nastavujem az po schovani biometry obrazovky lebo potrebujem vidiet ine texty v html pre onboarding
          // DIS Digital Identity service - odpoved ~Success pre selfie v procese registracie
          // Zobrazi info o uspechu 5s
          data.state = "success";
          $rootScope.biometryResolve(data);
          break;

        // Stavy k selfie
        case AutoCaptureService.captureStatesFromNative.selfieFailed:
          // DIS Digital Identity service - odpoved ~Failed pre selfie v procese registracie
          // Zobrazi info o neuspechu 5s
          $rootScope.biometryResolve({
            state: "failed",
            info: "",
            errorKey: $scope.errorStateDocument,
            initiator: "topScreen"
          });
          break;

        // Stavy k pause
        case AutoCaptureService.captureStatesFromNative.pause:

          switch (data.info) {
            case AutoCaptureService.documentCaptureStates.idFront:
            // Pauznutie skenovania prednej strany OP

            case AutoCaptureService.documentCaptureStates.idBack:
              // Pauznutie skenovania zadnej strany OP
              OnboardingService.setDocumentPause(true);
              break;
            case AutoCaptureService.faceCaptureStates.selfie:
              // Pauznutie skenovania tvare
              BiometryService.setBiometryPause(true);
              break;
          }
          break;

        // Stav Canceled
        case AutoCaptureService.captureStatesFromNative.canceled:
          $rootScope.hideDocument(true);
          $rootScope.hideBiometry();
          // Nastavujem stavovu premennu lebo predpokladam ze onboarding proces sa skoncil
          AutoCaptureService.setAutoCaptureState(false);
          $rootScope.BottomScreen("biometryOnboarding", { ...data, initiator: "screensApp" });
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: biometryOnboarding() cancelled');
          $rootScope.createLog(2, 'biometryOnboarding()', 'biometryOnboarding() cancelled');
          break;

        // Stav init ktory sa preposiela na webApp
        case AutoCaptureService.captureStatesFromNative.init:
          // Odstrani dot web auto capture componentu koli nepredvidatelnemu spravaniu SBSC-63
          $rootScope.stopBiometry(true);
          AutoCaptureService.setAutoCaptureState(AutoCaptureService.faceCaptureStates.selfie);
          $rootScope.BottomScreen("biometryOnboarding", { ...data, initiator: "screensApp" });
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: biometryOnboarding() init');
          $rootScope.createLog(2, 'biometryOnboarding()', 'biometryOnboarding() init');
          break;

        // Other - Invalid states
        default:
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: biometryOnboarding() invalid state: ' + data.state);
          $rootScope.createLog(2, 'biometryOnboarding()', '# ERROR: biometryOnboarding() invalid state: ' + data.state);
          break;
      }
    }

    // Funkcia sluzi ako callback odfotenia tvare pri logine pomocou biometrie
    async function documentPhotoTaken(imageData) {
      if (OnboardingService.getDocumentPause()) {
        return false;
      }
      // Kontrola stavu kamery pred spracovanim odfotenej fotky
      if (!CameraHealthCheckService.isCameraHealthy()) return;
      // Zastavenie animacie progressbaru a zobrazenie hlasky "Dokument sa odosiela..."
      $scope.setDocumentCaptured(true);
      OnboardingService.setDocumentPause(true);
      try {
        // Timestamp of face capture (windows local time). NativeApp uses windows local time too.
        var imageTimeStamp = Date.now();
        var base64 = await AutoCaptureService.blobToImage(imageData.image, AutoCaptureService.getAutoCaptureState());

        switch (AutoCaptureService.getAutoCaptureState()) {

          case AutoCaptureService.documentCaptureStates.idBack:
            setTimeout(onboardingIDBackSuccess(base64, imageTimeStamp), 0);
          break;

          case AutoCaptureService.documentCaptureStates.idFront:
          default:
            setTimeout(onboardingIDFrontSuccess(base64, imageTimeStamp), 0);
          break;

        }
      } catch (error) {
        // Log exception to console && kibana
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: documentPhotoTaken() error: ' + error);
        $rootScope.createLog(2, 'documentPhotoTaken()', '# imageTimeStamp: ' + imageTimeStamp + ' # ERROR: ' + error.toString());
        return false;
      } finally {
        // Clean
        imageTimeStamp = 0;
        base64 = 0;
      }
    }

    onboardingIDFrontSuccess = function (base64, imageTimeStamp) {
      return function() {
        try {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: onboardingIDFrontSuccess() { send foto } # imageTimeStamp: ' + imageTimeStamp);
          OnboardingIDFrontSuccess(base64, imageTimeStamp);
        } catch (err) {
          // Zrusi skenovanie dokumentov
          $rootScope.autoCaptureOnboarding({ "state": AutoCaptureService.captureStatesFromNative.idFrontFailed });
          // Log exception to console && kibana
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: onboardingIDFrontSuccess() # imageTimeStamp: ' + imageTimeStamp + ' error: ' + err.toString());
          $rootScope.createLog(2, 'onboardingIDFrontSuccess()', ' # imageTimeStamp: ' + imageTimeStamp + ' # ERROR: ' + err.toString());
        } finally {
          // Clean
          imageTimeStamp = 0;
          base64 = 0;
        }
      }
    }

    onboardingIDFrontFailed = function () {
      try {
        // Zrusi skenovanie dokumentov
        $rootScope.autoCaptureOnboarding({ "state": AutoCaptureService.captureStatesFromNative.idFrontFailed }, true);
        // Odosle info o timeoute na nativeApp
        OnboardingIDFrontFailed();
      } catch (e) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: autoCaptureOnboarding() undefined OnboardingIDFrontFailed()');
        $rootScope.createLog(2, 'autoCaptureOnboarding()', 'undefined OnboardingIDFrontFailed()');
      }
    }

    onboardingIDBackSuccess = function (base64, imageTimeStamp) {
      return function() {
        try {
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: onboardingIDBackSuccess() { send foto } # imageTimeStamp: ' + imageTimeStamp);
          OnboardingIDBackSuccess(base64, imageTimeStamp);
        } catch (err) {
          // Zrusi skenovanie dokumentov
          $rootScope.autoCaptureOnboarding({ "state": AutoCaptureService.captureStatesFromNative.idBackFailed });
          // Log exception to console && kibana
          $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: onboardingIDBackSuccess() # imageTimeStamp: ' + imageTimeStamp + ' error: ' + err.toString());
          $rootScope.createLog(2, 'onboardingIDBackSuccess()', ' # imageTimeStamp: ' + imageTimeStamp + ' # ERROR: ' + err.toString());
        } finally {
          // Clean
          imageTimeStamp = 0;
          base64 = 0;
        }
      }
    }

    onboardingIDBackFailed = function () {
      try {
        // Zrusi skenovanie dokumentov
        $rootScope.autoCaptureOnboarding({ "state": AutoCaptureService.captureStatesFromNative.idBackFailed }, true);
        // Odosle info o timeoute na nativeApp
        OnboardingIDBackFailed();
      } catch (e) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: autoCaptureOnboarding() undefined OnboardingIDBackFailed()');
        $rootScope.createLog(2, 'autoCaptureOnboarding()', 'undefined OnboardingIDBackFailed()');
      }
    }

    onboardingSelfieFailed = function () {
      try {
        // Zrusi selfie
        $rootScope.autoCaptureOnboarding({ "state": AutoCaptureService.captureStatesFromNative.selfieFailed });
        // Odosle info o timeoute na nativeApp
        OnboardingSelfieFailed();
      } catch (e) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: autoCaptureOnboarding() undefined OnboardingSelfieFailed()');
        $rootScope.createLog(2, 'autoCaptureOnboarding()', 'undefined OnboardingSelfieFailed()');
      }
    }

    $scope.setDocumentCaptured = function(captured) {
      // https://www.figma.com/design/BBdutQNjj712a377WGSeso/DOXXbet-sportbox?node-id=5187-66660&t=FYhlJpeoX8yadwld-0
      if (captured) {
        // Zorbazi "Dokument sa odosiela..."
        $scope.documentProgress = "photo_sending";
        // Vyplni progressbar na cely obvod
        $scope.strokeDasharrayValues = "";
      } else {
        // Skryje "Dokument sa odosiela..."
        $scope.documentProgress = "";
        // Spusti animaciu progressbaru
        $scope.strokeDasharrayValues = AutoCaptureService.documentProgressAnimationValues;
      }
      $rootScope.$$phase || $rootScope.$apply();
    }
  });
